export default [
  {
    path: "/",
    text: "Home"
  },
  {
    path: "#",
    text: "Cart"
  },

  {
    path: "/Store",
    text: "Store"
  },
  {
    path: "/About",
    text: "About"
  }
];



// WEBPACK FOOTER //
// ./src/content/navLinks.js